import React, { useEffect, useState } from 'react'
import TextField from '../../whitaijiFrontendLibrary/components/TextField'
import SmallMusicPlayer from '../SmallMusicPlayer'
import BlueButton from '../BlueButton'
import T from '../Translation'
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv'
import Loading from '../../whitaijiFrontendLibrary/components/Loading'

const AddQuotes = ({data}) => {
    const {concert, setConcert, songsData, generateElevenLabsVo, hideTestButtons } = data
    const [isLoading, setIsLoading] = useState(false)
    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
    if(isLoading) {
        return <Loading/>
    }
    return (
        <div>
           {concertSongs?.filter((x)=>x?.status !== "archived")?.map((concertSong, index)=> <AddQuote key={index} data={{concertSong, isLoading, setIsLoading, generateElevenLabsVo, hideTestButtons, songsData, concert, setConcert}} />)}
        </div>
    )
}

export default AddQuotes

export const AddQuote = ({data}) => {

    const {concertSong, concert, setConcert, generateElevenLabsVo, isLoading, setIsLoading, hideTestButtons} = data
    const [affirmation, setAffirmation] = useState(concertSong?.affirmation || "") 
    const [aiVoSource, setAiVoSource] = useState( `https://remind-public.s3.eu-north-1.amazonaws.com/aivo/${concertSong?._id}.mp3`)
    const concertSongs = !Array.isArray(concert?.songs) ? [] : concert?.songs
    const updatedSong = {...concertSong, affirmation: affirmation}
    const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("testFunction",
            {
                concert,
                concertSong,
                concertSongs
            }
        )
    }
    useEffect(() => {
        setAffirmation(concertSong?.affirmation || "")
        setAiVoSource(`https://remind-public.s3.eu-north-1.amazonaws.com/aivo/${concertSong?._id}.mp3?v=${Date.now()}`)
    }, [concertSong])

    const rigenerateVo = async() => {
        setIsLoading(true)
        await generateElevenLabsVo(updatedSong)
        setAiVoSource(`https://remind-public.s3.eu-north-1.amazonaws.com/aivo/${concertSong?._id}.mp3?v=${Date.now()}`)
        setIsLoading(false)
    }
    return (
        <div style={{ margin:"10px", border:"1px solid #ccc", borderRadius:"10px", padding:"15px" }}>
            <div onClick={testFunction} style={{fontWeight:"bold", display:"flex", flexDirection:"column", padding:"10px"}}>
                {concertSong?.title}:
            </div>
            <TextField 
                nChar={230}
                textArea={true}
                value={affirmation}
                onChange={(e) => {setAffirmation(e.target.value)}}
                onBlur={() => setConcert({
                    ...concert, 
                    songs: [...concertSongs
                    ?.map((s) => {
                        if(s?.songTemplateId === concertSong?.songTemplateId) {
                            return {...s, affirmation: affirmation}
                        }
                        return s
                    })
                ]
            })
                    }
            />
            
            <VisDiv rules={[concertSong?._id]}>
                <BlueButton text={<T obj={{en:"Regenerate voice", it:"Rigenera la voce"}} />} fn={rigenerateVo} />
            </VisDiv>
            <VisDiv rules={[concertSong?._id]} style={{margin:"10px", display:"flex", justifyContent:"center"}}>
                <SmallMusicPlayer hideScreen={true} songSource={aiVoSource} />
            </VisDiv>
       
        </div>
    )

}
